import { render, staticRenderFns } from "./dropdown-light-unit.vue?vue&type=template&id=a4ba87c0&"
import script from "./dropdown-light-unit.vue?vue&type=script&lang=ts&"
export * from "./dropdown-light-unit.vue?vue&type=script&lang=ts&"
import style0 from "./dropdown-light-unit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports